import { render } from "./percentagechart.vue?vue&type=template&id=34042db4&scoped=true"
import script from "./percentagechart.vue?vue&type=script&lang=js"
export * from "./percentagechart.vue?vue&type=script&lang=js"

import "./percentagechart.vue?vue&type=style&index=0&id=34042db4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34042db4"]])

export default __exports__